export class Profile {
  /**
   * Defines shape of documents in the profiles collection
   * @param { string} name - Public name for this user.
   * @param { boolean } paymentsEnabled - Indicates whether or not payments are enabled for this user.
   */
  constructor(name, paymentsEnabled) {
    this.name = name
    this.paymentsEnabled = paymentsEnabled
  }
}

export default Profile
